import { render, staticRenderFns } from "./NonComplianceHistoryConfigurationPanel.vue?vue&type=template&id=f0124698&"
import script from "./NonComplianceHistoryConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./NonComplianceHistoryConfigurationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports